import { Mail } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { EmailTemplateRoutes } from "./routes";
import { EmailTemplatePermissions } from "./permissions";

export const emailTemplateNav: INavItem = {
  labelKey: "nav.email_templates",
  icon: Mail,
  path: EmailTemplateRoutes.LIST,
  permissions: [EmailTemplatePermissions.READ],
  permissionPrefix: "Travel:EmailTemplates:",
  children: [
    {
      labelKey: "nav.email_templates_manage",
      path: EmailTemplateRoutes.LIST,
      permissions: [EmailTemplatePermissions.READ],
    },
  ],
};
